import React, { FC, useEffect } from 'react';
import './Messages.scss';
import { Routes } from '../../utils';
import { NetworkStatus } from '@apollo/client';
import { Query } from '../_common';
import { GET_CONVERSATION_PREVIEW_BY_USER_ID, GET_ALL_MESSAGES } from '../../graphql/client/queries';
import { MARK_ALL_AS_READ } from '../../graphql/client/mutations';
import { Error, Loading } from '../_common';
import { useStoreContext } from '../App/StoreProvider';
import MessageFilters from './MessageFilters';
import MessageHeader from './MessageHeader';
import MessageDriverList from './MessageDriverList';
import ConversationListItem from './ConversationListItem';
import { useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';

import MessagesDetail from './MessagesDetail';
import NotificationDetails from './NotificationDetails';
import * as MessageListActions from '../../store/actions/messageList';
import { useParams,  useLocation } from 'react-router-dom';
import {useNavigate} from 'react-router'


interface LooseObject {
    [key: string]: any;
}

const PAGE_SIZE = 50;

const Messages: FC = ({ match }: any): React.ReactElement => {

    const history = useNavigate();

    //  ='';
    
    //const params = matches[0].params;
    const { messageId } = useParams();
    const messageIdVal: any = messageId
    const [{ auth }] = useStoreContext();
    const [state, dispatch] = useStoreContext();
    const {
        messageList: { filters, searchPhrase, dateFilter },
    } = state;
    // const {
    //     loadManagementList: { filters: newfilters },
    // } = state;
    const [refetchQuery, setRefetchQuery] = React.useState(false);
    const [refetchDriverList, setRefetchDriverList] = React.useState(false);
    const [showFilter, setShowFilter] = React.useState(false);

    const [isFetching, setIsFetching] = React.useState(false);
    const [isNotificationFetching, setIsNotificationFetching] = React.useState(false);
    const [isDriverListFetching, setIsDriverListFetching] = React.useState(false);

    const abortController = React.useRef(new AbortController());
    const context = React.useMemo(() => {

        return {
            fetchOptions: {
                signal: abortController.current.signal,
            },
        }
    }, [abortController.current.signal]);

    const abortRequest = React.useCallback((): void => {
        abortController.current.abort();
    },[abortController.current]);

    useEffect(() => {
        const prevRoute = localStorage.getItem('previousPath');
        if (prevRoute !== 'home') {
            dispatch(MessageListActions.resetFilterState());
        } else {
            localStorage.removeItem('previousPath');
        }
    }, []);

    // const driverId = match.params.messageId;
    // const conversationId = match.params.conversationId;

    //const conversationId = (match) ? match.params.messageId : 0;
    const conversationId = (messageIdVal) ? (messageIdVal) : 0;
    
    const { regionIds, messageType, carrierIds } = filters;
    const allMessagesVariables = {
            input: {
                searchString: searchPhrase,
                dateFrom: filters.fromDate,
                dateTo: filters.toDate,
                filter: dateFilter,
                regionIds,
                carrierIds,
                pageSize: PAGE_SIZE,
                messageType: 'messages',
                filterByDrivers: true,
                filterByGroups: true,
            },
            offset: 0,
        }

    if (messageType.length > 0) {
        allMessagesVariables['input']['filterByDrivers'] =
            messageType.indexOf('filterByDrivers') > -1
                ? true
                : messageType.indexOf('filterByOnLoad') > -1 ||
                    messageType.indexOf('filterByOnShift') > -1 ||
                    messageType.indexOf('filterByWaitOnLoad') > -1
                    ? true
                    : false;
        allMessagesVariables['input']['filterByGroups'] = messageType.indexOf('filterByGroups') > -1 ? true : false;
        allMessagesVariables['input']['filterByOnLoad'] = messageType.indexOf('filterByOnLoad') > -1 ? true : false;
        allMessagesVariables['input']['filterByOnShift'] = messageType.indexOf('filterByOnShift') > -1 ? true : false;
        allMessagesVariables['input']['filterByWaitOnLoad'] =
            messageType.indexOf('filterByWaitOnLoad') > -1 ? true : false;
    }

    const [markAllAsRead, { loading: mutationLoading }] = useMutation<LooseObject>(MARK_ALL_AS_READ, {
        onCompleted: data => {
            
            setRefetchQuery(true);
            const driverDataSring = localStorage.getItem('driverData_' + messageIdVal);
            if (driverDataSring) {
                const driverData = JSON.parse(driverDataSring);
                driverData.driver['markAllRead'] = true;
                localStorage.setItem('driverData_' + messageIdVal, JSON.stringify(driverData));
                // if (driverData.driver.conversatonId == null) {
                //     driverData.driver.conversatonId = data.sendMessageToConversation.conversatonId;
                //     localStorage.setItem('driverData', JSON.stringify(driverData));
                // }
            }
        },
        refetchQueries: [
            // {
            //     query: GET_ALL_MESSAGES,
            //     variables: allMessagesVariables,
            // },
        ],
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
    });

    const markAllAsReadHander = React.useCallback(async () => {
        await markAllAsRead({
            variables: { input: { driverId: parseInt(messageIdVal) } },
        });
    },[messageIdVal]);

    document.title = 'Messages';

    

    return (
        <div className="Messages-Container">
            <div className="Messages-BodyContainer">
                <MessageFilters
                    history={history}
                    showFilter={showFilter}
                    showFilterHandler={() => setShowFilter(prevShowFilter => !prevShowFilter)}
                />
                <div id="MessagesFilterContainer" className="Messages-ListContainer">
                    <div className="Messages-LoadList" id="loadList">
                        <MessageHeader
                            match={match}
                            history={history}
                            abortRequest={abortRequest}
                            markAllAsReadHander={markAllAsReadHander}
                            showFilterHandler={() => setShowFilter(prevShowFilter => !prevShowFilter)}
                            isFetching={isDriverListFetching || isFetching || isNotificationFetching}
                        />
                        <div className="Row">
                            <div className="Driver-List-Section">
                                <MessageDriverList
                                    history={history}
                                    match={match}
                                    refetchQuery={refetchQuery}
                                    setRefetchQuery={setRefetchQuery}
                                    refetchDriverList={refetchDriverList}
                                    setRefetchDriverList={setRefetchDriverList}
                                    setIsFetching={setIsDriverListFetching}
                                />
                            </div>
                            {typeof messageIdVal === 'undefined' ? (

                                <>
                                    <div className="Message-List-Section">
                                        <Query<LooseObject>
                                            query={GET_ALL_MESSAGES}
                                            variables={allMessagesVariables}
                                            fetchPolicy="network-only"
                                            // nextFetchPolicy="cache-first"
                                            context={context}
                                            // notifyOnNetworkStatusChange={true}
                                            pollInterval={120000}
                                        >
                                            {({
                                                error,
                                                data,
                                                loading,
                                                fetchMore,
                                                refetch,
                                                networkStatus
                                            }): React.ReactElement | null => {

                                               
                                                React.useEffect(() => {
                                                    // if(loading)
                                                    setIsFetching(loading);
                                                }, [loading]);
                                                // setIsFetching(loading);
                                                if (error) {
                                                    return <Error error={error} />;
                                                }
                                                if (mutationLoading) {
                                                    return <Loading />;
                                                }
                                                const conversationList: LooseObject[] = [];
                                                if (data && data.getAllMessages && data.getAllMessages.length !== 0) {
                                                    data.getAllMessages.forEach((element: LooseObject | null): void => {
                                                        if (element !== null && element.isFromDriver == true) {
                                                            conversationList.push(element);
                                                        }
                                                    });
                                                }
                                                const offset =
                                                    data && data.getAllMessages && data.getAllMessages
                                                        ? data.getAllMessages.length / PAGE_SIZE
                                                        : 0;
                                                // setOffset(offsetNew);

                                                let isEndOfResults = false;
                                                if (
                                                    offset % 1 !== 0 ||
                                                    (!isEndOfResults &&
                                                        data &&
                                                        data.getAllMessages &&
                                                        data.getAllMessages.length < PAGE_SIZE)
                                                ) {
                                                    // If offset is not a whole number, the end of the results has been reached. (5/11/19) - KS
                                                    isEndOfResults = true;
                                                }
                                                return (
                                                    <ConversationListItem
                                                        abortRequest={abortRequest}
                                                        conversations={conversationList}
                                                        refetch={refetch}
                                                        isLoading={loading}
                                                        isEndOfResults={isEndOfResults}
                                                        history={history}
                                                        onLoadMore={() =>
                                                            fetchMore({
                                                                variables: {
                                                                    offset,
                                                                },
                                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                                    if (
                                                                        prev &&
                                                                        fetchMoreResult &&
                                                                        prev.getAllMessages &&
                                                                        fetchMoreResult.getAllMessages
                                                                    ) {
                                                                        return Object.assign({}, prev, {
                                                                            getAllMessages: [
                                                                                ...prev.getAllMessages,
                                                                                ...fetchMoreResult.getAllMessages,
                                                                            ],
                                                                        });
                                                                    } else {
                                                                        return prev;
                                                                    }
                                                                },
                                                            })
                                                        }
                                                    />
                                                );
                                            }}
                                        </Query>
                                    </div>
                                    <NotificationDetails
                                        history={history}
                                        match={match}
                                        setIsFetching={setIsNotificationFetching}
                                    />
                                </>
                            ) : (
                                <MessagesDetail
                                    match={match}
                                    history={history}
                                    refetchQuery={refetchQuery}
                                    setRefetchQuery={setRefetchQuery}
                                    markAllAsReadHander={markAllAsReadHander}
                                    setIsFetching={setIsNotificationFetching}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Messages;

